import { poiIcons } from './poiIcons'
import markerURL from './images/marker.png'
import highlightPointURL from './images/highlightPoint.svg'
// possible design improvement: the shape of this icon doesn't match any
// of our other POI icons.
import photoIconURL from './images/photo-icon.svg'
import liveLogIconUrl from './images/livelog-position@2x.png'
// TODO switch all of these to SVG
import milestoneIcon from './images/milestone-icon.svg'

// mapbox markers default to z-index: 1;, so if you need your mapbox marker to
// show up in a particular position in the stack, define that here. stack order
// is handled for you by !mapbox map engines
export const iconTypes = {
  default: {
    iconUrl: markerURL,
    iconSize: [24, 24],
    iconAnchor: [12, 12]
  },
  photo: {
    iconUrl: photoIconURL,
    iconSize: [26, 29],
    iconAnchor: [13, 29]
  },
  liveLogIcon: {
    iconUrl: liveLogIconUrl,
    iconSize: [36, 36],
    iconAnchor: [18, 18]
  },
  start: {
    iconUrl: '/images/start.svg',
    iconSize: [42, 42],
    iconAnchor: [21, 42]
  },
  stop: {
    iconUrl: '/images/stop.svg',
    iconSize: [42, 42],
    iconAnchor: [21, 42]
  },
  highlightPoint: {
    iconUrl: highlightPointURL,
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    zIndex: 0
  },
  milestone: {
    iconUrl: milestoneIcon,
    iconSize: [33, 37],
    iconAnchor: [16, 37],
    zIndex: 0
  },
  ...poiIcons
}

// legacy compat
iconTypes.photoIcon = iconTypes.photo
